import { __extends } from "tslib";
import { addClass, removeAllChildren, removeClass } from '@tyler-components-web/core';
import { BaseAdapter } from '../core/adapters/base-adapter';
import { TABLE_CONSTANTS } from './table-constants';
import { TableUtils } from './table-utils';
/**
 * Provides facilities for interacting with the internal DOM of `TableComponent`.
 */
var TableAdapter = /** @class */ (function (_super) {
    __extends(TableAdapter, _super);
    function TableAdapter(component) {
        return _super.call(this, component) || this;
    }
    TableAdapter.prototype.initialize = function () {
        if (!this._tableElement) {
            this._tableElement = document.createElement('table');
            this._tableElement.classList.add(TABLE_CONSTANTS.classes.TABLE);
            if (this._component.children.length) {
                removeAllChildren(this._component);
            }
            this._component.appendChild(this._tableElement);
        }
    };
    TableAdapter.prototype.getTableElement = function () {
        if (!this._tableElement) {
            this.initialize();
        }
        return this._tableElement;
    };
    TableAdapter.prototype.createTable = function (configuration) {
        return TableUtils.createTable(configuration);
    };
    TableAdapter.prototype.recreateTableBody = function (configuration) {
        TableUtils.recreateTableBody(configuration);
    };
    TableAdapter.prototype.setSelectedRows = function (tableElement, key, data, selectedRows, preserveExisting) {
        if (preserveExisting === void 0) { preserveExisting = false; }
        TableUtils.setSelectedRows(tableElement, key, data, selectedRows, preserveExisting);
    };
    TableAdapter.prototype.clearSelectedRows = function (tableElement) {
        TableUtils.clearSelectedRows(tableElement);
    };
    TableAdapter.prototype.updateSelectedState = function (rowElement, isSelected) {
        TableUtils.updateSelectedState(rowElement, isSelected);
    };
    TableAdapter.prototype.updateSelectAllState = function (tableElement, isAllSelected, isIndeterminate) {
        TableUtils.updateSelectAllState(tableElement, isAllSelected, isIndeterminate);
    };
    TableAdapter.prototype.setSortedColumn = function (tableElement, columnIndex, sortDirection) {
        TableUtils.setSortedColumn(tableElement, columnIndex, sortDirection);
    };
    TableAdapter.prototype.removeColumnSort = function (tableElement, columnIndex) {
        TableUtils.removeColumnSort(tableElement, columnIndex);
    };
    TableAdapter.prototype.setSortDirection = function (tableElement, columnIndex, sortDirection) {
        TableUtils.setSortDirection(tableElement, columnIndex, sortDirection);
    };
    TableAdapter.prototype.setSelectColumnVisibility = function (tableElement, isVisible, selectListener, selectAllListener, selectAllTemplate, selectCheckboxAlignment, data, tooltipSelect, tooltipSelectAll) {
        TableUtils.setSelectColumnVisibility(tableElement, isVisible, selectListener, selectAllListener || null, selectAllTemplate || null, selectCheckboxAlignment || null, data || [], tooltipSelect || null, tooltipSelectAll || null);
    };
    TableAdapter.prototype.setDense = function (tableElement, isDense) {
        TableUtils.setDenseState(tableElement, isDense);
    };
    TableAdapter.prototype.setRoomy = function (tableElement, isRoomy) {
        TableUtils.setRoomyState(tableElement, isRoomy);
    };
    TableAdapter.prototype.setResizable = function (configuration) {
        TableUtils.setResizable(configuration);
    };
    TableAdapter.prototype.setSelectAllVisibility = function (tableElement, isVisible, listener, selectAllTemplate, selectCheckboxAlignment, tooltipSelectAll) {
        if (tooltipSelectAll === void 0) { tooltipSelectAll = null; }
        TableUtils.setSelectAllVisibility(tableElement, isVisible, listener, selectAllTemplate, selectCheckboxAlignment || null, tooltipSelectAll || null);
    };
    TableAdapter.prototype.setFilterRow = function (configuration) {
        TableUtils.setFilterRow(configuration);
    };
    TableAdapter.prototype.expandRow = function (configuration, rowIndex, template) {
        return TableUtils.expandRow(configuration, rowIndex, template);
    };
    TableAdapter.prototype.collapseRow = function (configuration, rowIndex) {
        return TableUtils.collapseRow(configuration, rowIndex);
    };
    TableAdapter.prototype.isRowExpanded = function (configuration, rowIndex) {
        return TableUtils.isRowExpanded(configuration, rowIndex);
    };
    TableAdapter.prototype.setFixedHeaders = function (configuration) {
        TableUtils.setFixedHeaders(configuration);
    };
    TableAdapter.prototype.setTableLayoutType = function (configuration) {
        TableUtils.setLayoutType(configuration);
    };
    TableAdapter.prototype.setWrapContentState = function (configuration) {
        TableUtils.setWrapContentState(configuration.tableElement, configuration.wrapContent);
    };
    TableAdapter.prototype.addDocumentListener = function (type, listener) {
        TableUtils.getOwnerDocument(this._component).addEventListener(type, listener);
    };
    TableAdapter.prototype.removeDocumentListener = function (type, listener) {
        TableUtils.getOwnerDocument(this._component).removeEventListener(type, listener);
    };
    TableAdapter.prototype.normalizeColumnWidths = function (configuration) {
        TableUtils.normalizeColumnWidths(configuration);
    };
    TableAdapter.prototype.setResizeColumnVisibility = function (configuration, columnIndex, isVisible) {
        TableUtils.setColumnResizeIndicatorVisibility(configuration, columnIndex, isVisible);
    };
    TableAdapter.prototype.addTableClass = function (classes) {
        addClass(classes, this._tableElement);
    };
    TableAdapter.prototype.removeTableClass = function (classes) {
        removeClass(classes, this._tableElement);
    };
    TableAdapter.prototype.setRowClickListeners = function (tableElement, allowClick, clickListener, doubleClickListener) {
        TableUtils.setRowClickListeners(tableElement, allowClick, clickListener, doubleClickListener);
    };
    TableAdapter.prototype.setRowClickAttributes = function (tableElement, allowClick) {
        TableUtils.setRowClickAttributes(tableElement, allowClick);
    };
    return TableAdapter;
}(BaseAdapter));
export { TableAdapter };
